import { render, staticRenderFns } from "./NavMain.vue?vue&type=template&id=b28a9d88&scoped=true"
import script from "./NavMain.vue?vue&type=script&lang=js"
export * from "./NavMain.vue?vue&type=script&lang=js"
import style0 from "./NavMain.vue?vue&type=style&index=0&id=b28a9d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28a9d88",
  null
  
)

export default component.exports